import "core-js/modules/es.regexp.exec.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "layout-h5"
};
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { ref, computed, provide } from "vue";
import loginBoxH5 from '@/components/h5/popup/loginBoxH5';
import SignPopupH5 from '@/components/h5/popup/SignPopupH5';
import AvatarUploadH5 from '@/components/h5/popup/AvatarUploadH5';
import PalcodePopup from '@/components/popup/PalcodePopup';
import PalcodeSuccessPopup from '@/components/popup/PalcodeSuccessPopup';
import FirstTimeAvatarPopup from '@/components/popup/FirstTimeAvatarPopup';
import { homeCategoryTable } from "@/composable/commonFunction/categoryTable";
import dynamicRem from "@/utils/dynamicRem";
// import * as API from '@/api'

export default {
  __name: 'layoutH5',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const signPopup = computed(() => store.state.common.signPopup);
    const avatarUploadPopup = computed(() => store.state.common.avatarUploadPopup);
    const palcodePopup = computed(() => store.state.common.palcodePopup);
    const palcodeSuccessPopup = computed(() => store.state.common.palcodeSuccessPopup);
    const mainContentView = ref();
    const activeHeaderTab = ref(homeCategoryTable.filter(item => item.home)[0]['key']);
    const categoryTab = ref();
    const previousHeader = ref();
    provide('activeHeaderTab', {
      activeHeaderTab,
      switchHeaderTab
    });
    provide('categoryTab', {
      categoryTab,
      switchCategory
    });

    // 切換Header頁籤
    function switchHeaderTab(val) {
      activeHeaderTab.value = val;
      // console.log('activeHeaderTab.value',activeHeaderTab.value)
      // 切換 heder 路由時.要把圈子換到推薦-全部
      if (previousHeader.value === 'recommend') {
        categoryTab.value = 'all';
      }
      previousHeader.value = val;
    }

    // 切換圈子分類
    function switchCategory(val) {
      categoryTab.value = val;
      // console.log(`switchCategory: ${val}`);
    }

    // for test
    function showPalcodePopup() {
      store.dispatch('common/showPalcodePopup');
      // store.dispatch('common/showPalcodeSuccessPopup')
    }

    // android 橫屏下的字體大小動態修正
    const ios = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (!ios) {
      dynamicRem();
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, {
        name: "headerH5"
      }), _createVNode(_component_router_view, {
        name: "tabbarH5"
      }), _createVNode(_component_router_view, {
        name: "assistiveToolH5"
      }), _createVNode(_component_router_view, {
        name: "activityAssistiveToolH5"
      }), _createElementVNode("main", null, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [_unref(route).meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: 0
        })) : _createCommentVNode("", true)], 1024)), !_unref(route).meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      })]), _createVNode(_unref(loginBoxH5)), _unref(signPopup).show ? (_openBlock(), _createBlock(_unref(SignPopupH5), {
        key: 0
      })) : _createCommentVNode("", true), _unref(avatarUploadPopup).show ? (_openBlock(), _createBlock(_unref(AvatarUploadH5), {
        key: 1
      })) : _createCommentVNode("", true), _unref(palcodePopup).show ? (_openBlock(), _createBlock(_unref(PalcodePopup), {
        key: 2
      })) : _createCommentVNode("", true), _unref(palcodeSuccessPopup).show ? (_openBlock(), _createBlock(_unref(PalcodeSuccessPopup), {
        key: 3
      })) : _createCommentVNode("", true), _createVNode(_unref(FirstTimeAvatarPopup))]);
    };
  }
};